import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
// mock
import { API_URL } from '../../api';
export const DeleteModal = ({ deleteModal, handleDeleteModal, deleteId, setChild, setPlus, plus }) => {
  // ** Function to delete single role
  const deleteChild = async (id) => {
    await axios
      .delete(`${API_URL}/api/child/${id}`, {
        headers: {
          Authorization: cookies.get('TOKEN'),
        },
      })
      .then(
        () => {
          setPlus(plus + 1);
        },
        axios
          .get(`${API_URL}/api/child/`)
          .then((res) => {
            handleDeleteModal();
            setChild(res?.data);
            toast.success(res?.data?.message || 'Child Deleted Successfully.');
          })
          .catch((error) => {
            console.log(error);
            handleDeleteModal();
            toast.error(err?.response?.data?.message || 'Something went wrong');
          })
      );
  };

  return (
    <Dialog open={deleteModal}>
      <DialogTitle>Delete Child</DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle1">Are you sure? </Typography>
        <Typography variant="subtitle1">Once deleted data cannot be recovered.</Typography>
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          type="submit"
          style={{ fontFamily: 'Inter', minWidth: '90px' }}
          onClick={() => {
            deleteChild(deleteId);
          }}
        >
          Confirm
        </Button>
        <Button
          variant="contained"
          type="submit"
          style={{ fontFamily: 'Inter', minWidth: '90px' }}
          onClick={handleDeleteModal}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
